module.exports = __webpack_public_path__ + "img/Icon-Usuario-estrella.3723ac2d.svg";